import { createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "text-center sm:mx-auto flex flex-wrap gap-2 sm:gap-4 sm:text-lg text-sm mt-3 sm:mt-4" }
const _hoisted_2 = {
  class: "flex flex-1",
  id: "paper-stats"
}
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Cited By")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Citing")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Published")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Open Access")
const _hoisted_7 = ["href"]
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { key: 2 }
const _hoisted_10 = {
  key: 0,
  class: "flex flex-1",
  id: "graph-stats"
}
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Papers in Graph")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("Citations in Graph")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("Graph Depth")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_stat = _resolveComponent("stat")!
  const _component_SqlView = _resolveComponent("SqlView")!
  const _component_Stat = _resolveComponent("Stat")!

  return (_openBlock(), _createElementBlock("dl", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_stat, null, {
        name: _withCtx(() => [
          _hoisted_3
        ]),
        value: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.numCitedBy), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_stat, null, {
        name: _withCtx(() => [
          _hoisted_4
        ]),
        value: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.numCiting), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_stat, null, {
        name: _withCtx(() => [
          _hoisted_5
        ]),
        value: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.publishedYear), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_stat, null, {
        name: _withCtx(() => [
          _hoisted_6
        ]),
        value: _withCtx(() => [
          (_ctx.oaLink)
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                href: _ctx.oaLink,
                target: "_blank",
                class: "underline hover:no-underline"
              }, "Yes", 8, _hoisted_7))
            : (_ctx.loading)
              ? (_openBlock(), _createElementBlock("span", _hoisted_8, "-"))
              : (_openBlock(), _createElementBlock("span", _hoisted_9, "No"))
        ]),
        _: 1
      })
    ]),
    (_ctx.graphStats)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createVNode(_component_stat, null, {
            name: _withCtx(() => [
              _hoisted_11
            ]),
            value: _withCtx(() => [
              _createVNode(_component_SqlView, {
                view: 'stat',
                sql: `SELECT value FROM metadata WHERE name = 'paper_count'`,
                ids: _ctx.id ? [_ctx.id] : []
              }, null, 8, ["ids"])
            ]),
            _: 1
          }),
          _createVNode(_component_stat, null, {
            name: _withCtx(() => [
              _hoisted_12
            ]),
            value: _withCtx(() => [
              _createVNode(_component_SqlView, {
                view: 'stat',
                sql: `SELECT value FROM metadata WHERE name = 'citation_count'`,
                ids: _ctx.id ? [_ctx.id] : []
              }, null, 8, ["ids"])
            ]),
            _: 1
          }),
          _createVNode(_component_Stat, null, {
            name: _withCtx(() => [
              _hoisted_13
            ]),
            value: _withCtx(() => [
              _createVNode(_component_SqlView, {
                view: 'stat',
                sql: `SELECT value FROM metadata WHERE name = 'graph_depth'`,
                ids: _ctx.id ? [_ctx.id] : []
              }, null, 8, ["ids"])
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true)
  ]))
}